export default "__VITE_ASSET__BINusgFp__"